import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator';
import memoizeOne from 'memoize-one';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { withStyles } from '@material-ui/core';
import { RemoveRedEye as ViewIcon, Delete as DeleteIcon } from '@material-ui/icons';
import { FHETable } from 'data/components';
import renderEnvComponent from 'data/common/renderEnvComponent';
import getSelectors from '../selectors';

class TableHomeProducts extends Component {
    static propTypes = {
        classes: PropTypes.object.isRequired,
        profile: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired,
        homeProducts: PropTypes.object.isRequired,
        deleteProduct: PropTypes.func.isRequired
    };

    navigateToDetail = rowData => {
        const { history } = this.props;
        return history.push({
            pathname: `/${history.environment}/products/${rowData.homeId}/${rowData.productType}/${rowData.productIdentifier}`
        });
    };

    hasRightToDetail = rowData => {
        const { profile, history } = this.props;
        return (
            rowData.state !== Translator.translate('general.dissociated') &&
            (profile.get('admin') || profile.getIn(['user_rights', history.environment], []).includes(`products_${rowData.productType}_details`))
        );
    };

    hasRightToDelete = rowData => {
        const { profile, history } = this.props;
        return (
            rowData.state === Translator.translate('general.dissociated') &&
            (profile.get('admin') || profile.getIn(['user_rights', history.environment], []).includes(`products_${rowData.productType}_delete`))
        );
    };

    hideDeleteButton = rowData => {
        const { profile, history } = this.props;
        const deletableProductType = ['fhe_product', 'airzone'];

        return (
            deletableProductType.includes(rowData.productType) &&
            (profile.get('admin') || profile.getIn(['user_rights', history.environment], []).includes(`products_${rowData.productType}_delete`))
        );
    };

    renderActions = memoizeOne(profile => {
        const { history, deleteProduct } = this.props;
        const userRights = profile.getIn(['user_rights', history.environment], []);
        let actions = {
            row: [],
            toolbar: []
        };
        if (profile.get('admin') || userRights.includes('productsDetails')) {
            actions.row.push({
                icon: ViewIcon,
                hasRight: this.hasRightToDetail,
                onClick: this.navigateToDetail,
                tooltip: Translator.translate(`general.showDetail`)
            });
        }
        actions.row.push({
            icon: DeleteIcon,
            hasRight: this.hasRightToDelete,
            isHidden: this.hideDeleteButton,
            onClick: (rowData, callbackRowActionLoading) => {
                deleteProduct(rowData, callbackRowActionLoading);
            },
            tooltip: Translator.translate(`generic.products.actions.confirmationDeleteProductTitle`)
        });
        return actions;
    });

    renderData = memoizeOne(homeProducts => {
        let result = [];

        homeProducts.map((product, productkey) => {
            result.push({
                key: productkey,
                identifier: product
                    .get('identifier')
                    .match(/.{1,2}/g)
                    .join(':'),
                productIdentifier: product.get('identifier'),
                productType: product.get('productType'),
                homeId: parseInt(product.get('homeId')),
                type: product.get('productType') === 'fhe_product' ? product.get('type') : Translator.translate(`general.${product.get('type')}`),
                label: product.get('label'),
                version: product.get('version'),
                state: product.getIn(['state'], '') === '' ? '' : Translator.translate(`general.${product.get('state')}`),
                status: product.getIn(['status'], '') === '' ? '' : Translator.translate(`general.${product.get('status')}`),
                address_ip: product.get('addressIp')
            });
        });

        return result;
    });

    renderColumns = memoizeOne(() => {
        const { classes } = this.props;

        return [
            {
                title: Translator.translate('general.table.column.identifier'),
                name: 'identifier',
                width: 150
            },
            {
                title: Translator.translate('general.table.column.label'),
                name: 'label'
            },
            {
                title: Translator.translate('general.table.column.version'),
                name: 'version'
            },
            {
                title: Translator.translate('general.table.column.type'),
                name: 'type',
                grouped: 1
            },
            {
                title: Translator.translate('general.table.column.status'),
                name: 'state',
                render: (row, data, value) => {
                    if (!value) return null;
                    return (
                        <span className={value === Translator.translate('general.associated') ? classes.associated : classes.dissociated}>
                            {value}
                        </span>
                    );
                }
            },
            {
                title: Translator.translate('general.table.column.state'),
                name: 'status',
                render: (row, data, value) => {
                    if (!value) return null;
                    return (
                        <span className={value === Translator.translate('general.connected') ? classes.connected : classes.disconnected}>
                            {value}
                        </span>
                    );
                }
            },
            {
                title: Translator.translate('general.table.column.addressIp'),
                name: 'address_ip'
            }
        ];
    });

    render() {
        const { homeProducts, profile, history } = this.props;

        return (
            <FHETable
                idTable="homeDetailProduct"
                columns={this.renderColumns()}
                data={this.renderData(homeProducts)}
                actions={this.renderActions(profile)}
                minified
                emptyDataSourceMessage={Translator.translate(`generic.products.table.body.emptyDataSourceMessage`)}
            />
        );
    }
}
function mapStateToProps(state, props) {
    const { history } = props;
    const homeId = props.match.params.homeId;
    const selectors = getSelectors(history.environment);
    return {
        profile: selectors.getProfile(state),
        homeProducts: selectors.getProductsByHomeId(state, homeId)
    };
}

const styles = theme => ({
    associated: {
        color: theme.palette.success.main
    },
    dissociated: {
        color: theme.palette.error.main
    },
    connected: {
        color: theme.palette.success.main
    },
    disconnected: {
        color: theme.palette.error.main
    }
});

export default withRouter(
    renderEnvComponent('scenes/Home/tables/TableHomeProducts', connect(mapStateToProps)(withStyles(styles, { withTheme: true })(TableHomeProducts)))
);



// WEBPACK FOOTER //
// ./environments/genericEnv/scenes/Home/tables/TableHomeProducts.js